import Paper from "@mui/material/Paper";
import React from "react";
import { isMobile } from "react-device-detect";
import TabPanel from "../../../../components/carousel/TabPanel";
import ProposicaoAcaoPreparatoriaEspecificaNotaTecnica from "./ProposicaoAcaoPreparatoriaEspecificaNotaTecnica";
import { IAcaoPreparatoria } from "../../../../models/Proposicao.Model";

const ProposicaoAcaoPreparatoriaEspecificaCarrouselTabsNotaTecnica = (props: {
  activeTab: any;
  index: number;
  acao: IAcaoPreparatoria;
  onChange: (data: any) => void;
  reload?: () => void;
  podeEditar?: boolean;
}) => {

  return (
    <TabPanel value={props.activeTab} index={props.index}>
      <Paper
        style={{
          borderRadius: "6px",
          marginTop: `${isMobile ? "0px" : "0px"}`,
        }}
      >
        <ProposicaoAcaoPreparatoriaEspecificaNotaTecnica
          acao={props.acao}
          lista={props.acao?.notaTecnica?.lista}
          listaII={props.acao?.notaTecnica?.listaII}
          onChange={props.onChange}
          reload={() => {
            props?.reload();
          }}
          podeEditar={props.podeEditar}
        />
      </Paper>
    </TabPanel>
  );
};

export default ProposicaoAcaoPreparatoriaEspecificaCarrouselTabsNotaTecnica;
